import { ActionPattern } from "../default-constants";
import {
  APPROVAL_AFTER,
  EXAMINATION_RESULT,
  NEW_OR_PULLBACK,
  REQUEST_AFTER_FOR_APPROVER,
  REQUEST_AFTER_FOR_APPROVER_ADMIN,
  REQUEST_AFTER_FOR_REQUESTER,
  SEND_BACK,
} from "./constants";

/**
 * 画面表示を切り替えるための定数を返却する.
 * 0: 新規・引戻後, 1: 差戻後, 2: 承認依頼後(依頼者), 3: 承認依頼後(承認者(ドコモ管理者)), 4: 承認依頼後(承認者), 5: 承認後
 * @param {number | undefined} approvalAction 承認アクション
 * @param {string | undefined} actionBy アクションユ－ザ－
 * @param {string} loginUser ログインユーザー名
 * @param {boolean} isDocomoAdminUser ドコモ管理者かどうか
 * @returns {number} 画面表示を切り替えるための定数
 */
export const getCurrentStage = (
  approvalAction: number | undefined,
  actionBy: string | undefined,
  loginUser: string,
  isDocomoAdminUser: boolean
) => {
  const { approvalRequest, sendBack, approval } = ActionPattern;
  switch (approvalAction) {
    case sendBack.statusCode:
      return SEND_BACK;
    case approvalRequest.statusCode:
      // ログインユーザーが承認依頼を出したかどうかで判別
      if (actionBy === loginUser) {
        return REQUEST_AFTER_FOR_REQUESTER;
      } else if (isDocomoAdminUser) {
        return REQUEST_AFTER_FOR_APPROVER_ADMIN;
      } else {
        return REQUEST_AFTER_FOR_APPROVER;
      }
    case approval.statusCode:
      return APPROVAL_AFTER;
    default:
      return NEW_OR_PULLBACK;
  }
};

/**
 * 審査結果ラベルを返却する.
 * 201: NG, 301: OK, 399: 自動審査済
 * @param {string} examinationResult 審査結果値
 * @returns {string} 審査結果ラベル
 */
export const getDisplayExaminationResult = (examinationResult: string) => {
  switch (examinationResult) {
    case EXAMINATION_RESULT.ng.value:
      return EXAMINATION_RESULT.ng.label;
    case EXAMINATION_RESULT.ok.value:
      return EXAMINATION_RESULT.ok.label;
    case EXAMINATION_RESULT.automaticExamination.value:
      return EXAMINATION_RESULT.automaticExamination.label;
    default:
      return "";
  }
};
